import { SecurityProjectDetails } from '@lfx/core/models';

export interface SecurityProjectDetailsResult {
  rootSecurityProjectDetails: SecurityProjectDetails;
}
